import React, { useState } from 'react';
import {
  Button,
  Center,
  Flex,
  FormControl,
  FormErrorMessage,
  FormHelperText,
  FormLabel,
  Heading,
  Input,
  Link as ChakraLink,
  Stack,
  Text,
  useDisclosure,
} from '@chakra-ui/react';
import { ChangePasswordForm, useChangePasswordForm } from '../hooks/useChangePasswordForm';
import api from '../../../services/api';
import useAuth from '../../../hooks/useAuth';
import { ChangePasswordModal } from '../components/ChangePasswordModal';
import { Required } from '../../../components/Required';
import { Link as RouterLink, useNavigate } from 'react-router-dom';
import { MdKeyboardArrowLeft } from 'react-icons/md';


export const ChangePassword = () => {
  const { controls, errors, handleSubmit } = useChangePasswordForm();
  const { user } = useAuth();
  const { isOpen, onOpen, onClose } = useDisclosure();
  const [error, setError] = useState<boolean>(false);
  const navigate = useNavigate();

  const submit = async (value: ChangePasswordForm) => {
    setError(false);
    try {
      await api.put('/password', value, {
        headers: {
          Authorization: `Bearer ${user?.access_token}`,
        },
      });
    } catch (e) {
      setError(true);
    } finally {
      onOpen();
    }
  };

  return (
    <Flex flexDirection="column">
      <ChangePasswordModal isOpen={isOpen} onClose={onClose} isSuccess={!error} />

      <Heading as='h2' fontSize="xl">Seguridad</Heading>

      <ChakraLink as={RouterLink} to="../." color="neutral.800" >
        <Flex alignItems="center" marginTop="l">
          <MdKeyboardArrowLeft />
          <Text marginLeft="l">Volver a seguridad</Text>
        </Flex>
      </ChakraLink>

      <Text marginTop="xl" marginBottom="xxxl">Recuerda que debes crear una contraseña diferente, no puede ser la misma
        que las contraseñas anteriores. </Text>

      <form>
        <Center marginTop="xxxl">
          <Stack spacing="xl" borderWidth="1px" borderColor="neutral.300" borderRadius="xl" padding="xxxl" width="50em">
            <FormControl paddingX="xl" marginBottom="l" isInvalid={!!errors.oldPassword}>
              <FormLabel>Contraseña actual<Required /></FormLabel>
              <Input type="password" placeholder="****************" {...controls.oldPassword} />
              <FormErrorMessage>{errors.oldPassword?.message}</FormErrorMessage>
            </FormControl>
            <FormControl paddingX="xl" marginBottom="l" isInvalid={!!errors.newPassword}>
              <FormLabel>Nueva contraseña<Required /></FormLabel>
              <Input type="password" placeholder="****************" {...controls.newPassword} />
              <FormErrorMessage>{errors.newPassword?.message}</FormErrorMessage>
              <FormHelperText fontSize="s" color="grey.700">La contraseña debe tener al menos 8 caracteres, un número y
                una mayúscula</FormHelperText>
            </FormControl>
            <FormControl paddingX="xl" isInvalid={!!errors.confirmPassword}>
              <FormLabel>Repetir nueva contraseña<Required /></FormLabel>
              <Input type="password" placeholder="****************" {...controls.confirmPassword} />
              <FormErrorMessage>{errors.confirmPassword?.message}</FormErrorMessage>
            </FormControl>
          </Stack>
        </Center>
      </form>
      <Flex justifyContent="flex-end" marginTop="auto">
        <Button colorScheme="gray" marginRight="l" onClick={() => navigate('/settings/security')}>Cancelar</Button>
        <Button colorScheme="blue" onClick={handleSubmit(submit)}>Confirmar nueva contraseña</Button>
      </Flex>
    </Flex>
  );
};
